"use client";

import type { VariantProps } from "class-variance-authority";
import { cva } from "cva";
import {
  BaseButton,
  type BaseButtonProps,
} from "#ui-atoms/atoms/button/button";

const freemanButtonVariants = cva({
  base: "font-bold",
  variants: {
    variant: {
      default: "bg-foreground hover:bg-black",
      secondary: "bg-primary",
      outline: "",
      ghost: "",
      destructive: "",
      "destructive-outline": "",
      link: "",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface FreemanButtonProps
  extends BaseButtonProps,
    VariantProps<typeof freemanButtonVariants> {}

export default function FreemanButton({
  className,
  variant,
  ...props
}: FreemanButtonProps) {
  return (
    <BaseButton
      {...props}
      className={freemanButtonVariants({ variant, className })}
      isNestedTenantComponent={true}
      variant={variant}
    />
  );
}
